import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { IconComponent } from '../../../shared/components/icon/icon.component';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';

/**
 * Formly FieldArrayType for report filter rows.
 *
 * Each row is a fieldGroup of [field, operator, value]; operator options and
 * value visibility react to the selected field via `expressions` configured by
 * the report builder (see report-builder.component). This component only handles
 * generic row rendering plus add/remove.
 */
@Component({
  selector: 'app-report-filter-list',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormlyModule,
    ButtonComponent,
    IconComponent,
    TranslatePipe,
  ],
  templateUrl: './report-filter-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './report-filter-list.component.css',
})
export class ReportFilterListComponent extends FieldArrayType {}
